import { createContext, useContext, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setVendorAuth, clearVendorAuth, updateVendorAuth } from "../state/slices/vendorSlice";
import { clearUser } from "../state/slices/userSlice";

const VendorAuthContext = createContext();

export const VendorAuthProvider = ({ children }) => {
    const dispatch = useDispatch();
    const vendor = useSelector((state) => state.vendors.authVendor);
    const vendorToken = useSelector((state) => state.vendors.vendorToken);
    const status = useSelector((state) => state.vendors.status);
    const loading = status === "loading";

    // Listen for user-login event → clear vendor session
    useEffect(() => {
        const handleVendorLogout = () => dispatch(clearVendorAuth());
        window.addEventListener("vendor-logout", handleVendorLogout);
        return () => window.removeEventListener("vendor-logout", handleVendorLogout);
    }, [dispatch]);

    const loginVendor = useCallback((vendorData, token) => {
        dispatch(clearUser());
        window.dispatchEvent(new Event("user-logout"));
        dispatch(setVendorAuth({ vendor: vendorData, token }));
    }, [dispatch]);

    const logoutVendor = useCallback(() => {
        dispatch(clearVendorAuth());
    }, [dispatch]);

    const updateVendor = useCallback((vendorData) => {
        dispatch(updateVendorAuth(vendorData));
    }, [dispatch]);

    return (
        <VendorAuthContext.Provider
            value={{
                vendor,
                vendorToken,
                loading,
                loginVendor,
                logoutVendor,
                updateVendor,
                isVendorAuthenticated: !!vendorToken,
            }}
        >
            {children}
        </VendorAuthContext.Provider>
    );
};

export const useVendorAuth = () => useContext(VendorAuthContext);
